import React from 'react';
import { Page, Text, View, Document, StyleSheet, Font } from '@react-pdf/renderer';

Font.register({
    family: 'Bold',
    src: '../../assets/fonts/bold.ttf',
});
Font.register({
    family: 'ExtraLight',
    src: '../../assets/fonts/extralight.ttf',
});
Font.register({
    family: 'Regular',
    src: '../../assets/fonts/regular.ttf',
});

const styles = StyleSheet.create({
    body: {
        padding: 20,
    },
    title: {
        fontSize: 28,
        textAlign: 'center',
        marginBottom: 10,
        fontFamily: 'Bold',
    },
    subtitle: {
        fontSize: 18,
        marginTop: 15,
        marginBottom: 5,
        fontFamily: 'Bold',
        color: '#0d6efd',
    },
    studentInfo: {
        flexDirection: 'column',
        justifyContent: 'space-between',
        marginBottom: 10
    },
    table: {
        display: 'table',
        width: 'auto',
        borderStyle: 'solid',
        borderWidth: 1,
        borderRightWidth: 0,
        borderBottomWidth: 0,
        marginBottom: 10,
    },
    text: {
        fontSize: 10,
        fontWeight: 'normal',
    },
    tableRow: {
        flexDirection: 'row',
    },
    tableCol: {
        borderStyle: 'solid',
        borderWidth: 1,
        borderLeftWidth: 0,
        borderTopWidth: 0,
    },
    tableCell: {
        fontSize: 9,
        padding: 5,
    },
    courseTitle: {
        fontSize: 14,
        marginVertical: 5,
        fontFamily: 'Regular',
    },
    cardHeader: {
        backgroundColor: '#f8f9fa',
        padding: 8,
        borderBottom: 1,
        borderBottomColor: '#dee2e6',
    },
    sectionTitle: {
        fontSize: 12,
        marginTop: 10,
        marginBottom: 5,
        fontFamily: 'Bold',
        color: '#0d6efd',
    },
    legend: {
        fontSize: 8,
        marginTop: 3,
        marginBottom: 3,
        fontFamily: 'Regular',
    },
    badge: {
        fontSize: 7,
        padding: '2px 4px',
        borderRadius: 2,
        backgroundColor: '#6c757d',
        color: 'white',
        marginLeft: 4,
    },
    badgeSuccess: {
        fontSize: 7,
        padding: '2px 4px',
        borderRadius: 2,
        backgroundColor: '#198754',
        color: 'white',
        marginLeft: 4,
    },
    badgeDanger: {
        fontSize: 7,
        padding: '2px 4px',
        borderRadius: 2,
        backgroundColor: '#dc3545',
        color: 'white',
        marginLeft: 4,
    },
    badgeWarning: {
        fontSize: 7,
        padding: '2px 4px',
        borderRadius: 2,
        backgroundColor: '#ffc107',
        color: 'black',
        marginLeft: 4,
    },
});

const GerarHistoricoEscolar = ({ data }) => {

    const Table = ({ children }) => (
        <View style={styles.table}>{children}</View>
    );

    const Row = ({ children }) => (
        <View style={styles.tableRow}>{children}</View>
    );

    const Cell = ({ children, style }) => (
        <View style={[styles.tableCol, style]}>
            <Text style={styles.tableCell}>{children}</Text>
        </View>
    );


    return (
        <Document>
            <Page size="A4">
                <View style={styles.body}>
                    <Text style={styles.title}>Histórico Escolar</Text>
                    <View style={styles.studentInfo}>
                        <View style={styles.studentInfo}>
                            <Text style={{ fontFamily: 'Bold', fontSize: 10 }}>Nome: <Text style={{ fontFamily: 'Regular' }}>{data.info_usuario?.nome_completo || 'N/A'}</Text></Text>
                            <Text style={{ fontFamily: 'Bold', fontSize: 10 }}>E-mail: <Text style={{ fontFamily: 'Regular' }}>{data.info_usuario?.email || 'N/A'}</Text></Text>
                            <Text style={{ fontFamily: 'Bold', fontSize: 10 }}>Código: <Text style={{ fontFamily: 'Regular' }}>{data.info_usuario?.codigo || 'N/A'}</Text></Text>
                            <Text style={{ fontFamily: 'Bold', fontSize: 10 }}>Unidade: <Text style={{ fontFamily: 'Regular' }}>{data.info_usuario?.unidade || 'N/A'}</Text></Text>
                        </View>
                    </View>
                    
                    {data.topico && data.topico.map(topic => (
                        <View key={topic.idTopico}>
                            <Text style={styles.subtitle}>Tópico: {topic.nomeTopico}</Text>
                            
                            {topic.cursos && topic.cursos.map(course => (
                                <View key={course.idCurso} style={{ marginBottom: 20 }}>
                                    <View style={styles.cardHeader}>
                                        <Text style={{ fontFamily: 'Bold', fontSize: 12 }}>{course.nomeCurso}</Text>
                                    </View>
                                    
                                    {/* Tabela de resumo por módulo */}
                                    <Text style={styles.sectionTitle}>Resumo por Módulo</Text>
                                    <Table>
                                        <Row>
                                            <Cell style={{ width: '40%', fontFamily: 'Bold' }}>Módulo</Cell>
                                            <Cell style={{ width: '20%', textAlign: 'center', fontFamily: 'Bold' }}>Carga Horária</Cell>
                                            <Cell style={{ width: '20%', textAlign: 'center', fontFamily: 'Bold' }}>Nota Final</Cell>
                                            <Cell style={{ width: '20%', textAlign: 'center', fontFamily: 'Bold' }}>Situação</Cell>
                                        </Row>
                                        {course.modulos && course.modulos.map(modulo => (
                                            <Row key={modulo.idModulo}>
                                                <Cell style={{ width: '40%' }}>{modulo.nomeModulo}</Cell>
                                                <Cell style={{ width: '20%', textAlign: 'center' }}>{modulo.cargaHoraria.split(':')[0] || '-'}</Cell>
                                                <Cell style={{ width: '20%', textAlign: 'center' }}>{modulo.nota !== null ? modulo.nota : "CUR"}</Cell>
                                                <Cell style={{ width: '20%', textAlign: 'center' }}>
                                                    {modulo.situacao === 'Aprovado' ? 
                                                        <Text><Text style={styles.badgeSuccess}>Aprovado</Text></Text> : 
                                                        <Text><Text style={styles.badgeDanger}>Reprovado</Text></Text>}
                                                </Cell>
                                            </Row>
                                        ))}
                                    </Table>
                                    
                                    {/* Tabela detalhada de avaliações */}
                                    <Text style={styles.sectionTitle}>Detalhes das Avaliações</Text>
                                    <Table>
                                        <Row>
                                            <Cell style={{ width: '35%', fontFamily: 'Bold' }}>Módulo/Avaliação</Cell>
                                            <Cell style={{ width: '15%', textAlign: 'center', fontFamily: 'Bold' }}>Tipo</Cell>
                                            <Cell style={{ width: '15%', textAlign: 'center', fontFamily: 'Bold' }}>Nota</Cell>
                                            <Cell style={{ width: '20%', textAlign: 'center', fontFamily: 'Bold' }}>Data</Cell>
                                            <Cell style={{ width: '15%', textAlign: 'center', fontFamily: 'Bold' }}>Situação</Cell>
                                        </Row>
                                        
                                        {course.modulos && course.modulos.map(modulo => (
                                            <React.Fragment key={`detail-${modulo.idModulo}`}>
                                                {/* Avaliações principais */}
                                                {modulo.avaliacoes && modulo.avaliacoes.map((avaliacao, idx) => (
                                                    <Row key={`av-${modulo.idModulo}-${idx}`}>
                                                        <Cell style={{ width: '35%' }}>
                                                            {modulo.nomeModulo}
                                                        </Cell>
                                                        <Cell style={{ width: '15%', textAlign: 'center' }}>Principal</Cell>
                                                        <Cell style={{ width: '15%', textAlign: 'center', fontFamily: 'Bold' }}>{avaliacao.nota !== null ? avaliacao.nota : "N/A"}</Cell>
                                                        <Cell style={{ width: '20%', textAlign: 'center' }}>{avaliacao.data_formatada || 'N/A'}</Cell>
                                                        <Cell style={{ width: '15%', textAlign: 'center' }}>
                                                            {avaliacao.situacao === 'Aprovado' ? 
                                                                <Text><Text style={styles.badgeSuccess}>Aprovado</Text></Text> : 
                                                                <Text><Text style={styles.badgeDanger}>Reprovado</Text></Text>}
                                                        </Cell>
                                                    </Row>
                                                ))}
                                                
                                                {/* Avaliações extras */}
                                                {modulo.avaliacoes_extras && modulo.avaliacoes_extras.map((avaliacao, idx) => (
                                                    <Row key={`extra-${modulo.idModulo}-${idx}`}>
                                                        <Cell style={{ width: '35%' }}>
                                                            {avaliacao.nomeAvaliacaoExtra}
                                                            {avaliacao.arquivado === 1 && <Text style={styles.badgeWarning}>Renovação</Text>}
                                                        </Cell>
                                                        <Cell style={{ width: '15%', textAlign: 'center' }}>Extra</Cell>
                                                        <Cell style={{ width: '15%', textAlign: 'center', fontFamily: 'Bold' }}>{avaliacao.nota !== null ? avaliacao.nota : "N/A"}</Cell>
                                                        <Cell style={{ width: '20%', textAlign: 'center' }}>{avaliacao.data_formatada || 'N/A'}</Cell>
                                                        <Cell style={{ width: '15%', textAlign: 'center' }}>
                                                            {avaliacao.situacao === 'Aprovado' ? 
                                                                <Text><Text style={styles.badgeSuccess}>Aprovado</Text></Text> : 
                                                                <Text><Text style={styles.badgeDanger}>Reprovado</Text></Text>}
                                                        </Cell>
                                                    </Row>
                                                ))}
                                            </React.Fragment>
                                        ))}
                                    </Table>
                                </View>
                            ))}
                        </View>
                    ))}
                </View>
            </Page>
        </Document>
    );
};

export default GerarHistoricoEscolar;
